export default __webpack_public_path__ + "static/media/copima-logo.7d3fe9db.svg";